import {
	useHistory
} from 'react-router-dom';
import Home from './../components/home';

export default function PageHome() {
	let history = useHistory();
	return <Home history={history}/>;
}